import { render, staticRenderFns } from "./PatProfileBPage.vue?vue&type=template&id=d412328a"
import script from "./PatProfileBPage.vue?vue&type=script&lang=js"
export * from "./PatProfileBPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports